export const WIDGET_SETTINGS_KEY = "answer_engine_widget_settings";

// Combined Google Fonts URL for all preset font picker options.
// Loaded lazily only when the Answer Engine settings page is mounted.
export const PRESET_FONTS_HREF =
  "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700" +
  "&family=Lato:wght@400;700" +
  "&family=Montserrat:wght@400;500;700" +
  "&family=Open+Sans:wght@400;600;700" +
  "&family=Poppins:wght@400;500;700" +
  "&family=Raleway:wght@400;500;700" +
  "&family=Roboto:wght@400;500;700" +
  "&family=Source+Serif+4:ital,opsz,wght@0,8..60,400;0,8..60,600;1,8..60,400" +
  "&display=swap";

export const WIDGET_SETTINGS_DEFAULTS = {
  accentColor: "#2DC6FE",
  chatThemeColor: "",
  modalTitle: "",
  modalTitleFont: "",
  widgetMode: "bubble",
  versionId: "",
  bannerTitle: "",
  bannerDescription: "",
  bannerImageUrl: "",
  suggestedQuestions: [],
  glassDialogOpacity: "",
  glassScrimOpacity: "",
  glassBlur: "",
  glassChatOpacity: "",
  calendlyUrl: "",
  bookingCtaTitle: "",
  bookingCtaButton: "",
  hubspotPortalId: "",
  hubspotFormId: "",
  hubspotRegion: "",
};

export const WIDGET_MODE_OPTIONS = ["bubble", "spotlight"];

export const FONT_OPTIONS = [
  { label: "Default (sans-serif)", value: "" },
  { label: "Inter", value: "Inter, sans-serif" },
  { label: "Roboto", value: "Roboto, sans-serif" },
  { label: "Open Sans", value: "Open Sans, sans-serif" },
  { label: "Lato", value: "Lato, sans-serif" },
  { label: "Montserrat", value: "Montserrat, sans-serif" },
  { label: "Poppins", value: "Poppins, sans-serif" },
  { label: "Georgia", value: "Georgia, serif" },
  { label: "Source Serif 4 Semibold", value: "'Source Serif 4', serif" },
  { label: "Custom…", value: "__custom__" },
];

export function loadWidgetSettings() {
  try {
    const raw = localStorage.getItem(WIDGET_SETTINGS_KEY);
    if (!raw) return { ...WIDGET_SETTINGS_DEFAULTS };
    return { ...WIDGET_SETTINGS_DEFAULTS, ...JSON.parse(raw) };
  } catch {
    return { ...WIDGET_SETTINGS_DEFAULTS };
  }
}

export function persistWidgetSettings(settings) {
  try {
    localStorage.setItem(WIDGET_SETTINGS_KEY, JSON.stringify(settings));
    return true;
  } catch {
    return false;
  }
}

export function isValidHex(v) {
  return /^#[0-9a-fA-F]{6}$/.test(v);
}

export function normalizeWidgetMode(value) {
  const mode = (value || "").toString().trim().toLowerCase();
  return WIDGET_MODE_OPTIONS.includes(mode)
    ? mode
    : WIDGET_SETTINGS_DEFAULTS.widgetMode;
}

/** Map an API widget-config response (snake_case) to local settings state. */
export function mapApiToSettings(data) {
  if (!data) return null;
  return {
    accentColor: data.accent_color || WIDGET_SETTINGS_DEFAULTS.accentColor,
    bannerDescription: data.banner_description ?? "",
    bannerImageUrl: data.banner_image_url ?? "",
    bannerTitle: data.banner_title ?? "",
    glassBlur: data.blur != null ? data.blur : "",
    calendlyUrl: data.calendly_url ?? "",
    glassChatOpacity: data.chat_opacity != null ? data.chat_opacity : "",
    bookingCtaButton: data.cta_button_text ?? "",
    bookingCtaTitle: data.cta_title ?? "",
    glassDialogOpacity: data.dialog_opacity != null ? data.dialog_opacity : "",
    hubspotFormId: data.hubspot_form_id ?? "",
    hubspotPortalId: data.hubspot_portal_id ?? "",
    hubspotRegion: data.hubspot_region ?? "",
    modalTitle: data.modal_title ?? "",
    glassScrimOpacity: data.scrim_opacity != null ? data.scrim_opacity : "",
    suggestedQuestions: Array.isArray(data.suggested_questions)
      ? data.suggested_questions
      : [],
    modalTitleFont: data.title_font ?? "",
    widgetMode: normalizeWidgetMode(data.widget_mode),
  };
}
